import { useTheme } from 'styled-components';
import {
  PercentageFirst,
  Fee,
  PercentageLineFirst,
  DashboardConvertCardLoader,
  AmountFirst,
  PercentageLineSecond,
  PercentageSecond,
  AmountSecond,
  PercentageLineThird,
  PercentageThird,
  AmountThird,
} from './styles';

export const DashboardConvertFeeCardLoader = () => {
  const { colors } = useTheme();
  return (
    <DashboardConvertCardLoader
      backgroundColor={colors.surface.interactiveDefault}
      foregroundColor={colors.surface.pressed}
    >
      <Fee />
      <PercentageLineFirst />
      <PercentageFirst />
      <AmountFirst />
      <PercentageLineSecond />
      <PercentageSecond />
      <AmountSecond />
      <PercentageLineThird />
      <PercentageThird />
      <AmountThird />
    </DashboardConvertCardLoader>
  );
};
